// extracted by mini-css-extract-plugin
module.exports = {"link":"DiscoverLink_link__HesUi"};